var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M4.75322 0.711754C5.0626 0.989879 5.0876 1.46175 4.80947 1.77113L2.55947 4.27113C2.42197 4.42425 2.22822 4.51488 2.02197 4.518C1.81572 4.52113 1.61885 4.443 1.47197 4.29925L0.218848 3.04925C-0.0717774 2.7555 -0.0717774 2.2805 0.218848 1.98675C0.509473 1.693 0.987598 1.693 1.27822 1.98675L1.96885 2.67738L3.69072 0.764879C3.96885 0.455504 4.44072 0.430504 4.7501 0.708629L4.75322 0.711754ZM4.75322 5.71175C5.0626 5.98988 5.0876 6.46175 4.80947 6.77113L2.55947 9.27113C2.42197 9.42425 2.22822 9.51488 2.02197 9.518C1.81572 9.52113 1.61885 9.443 1.47197 9.29925L0.218848 8.04925C-0.0749023 7.7555 -0.0749023 7.2805 0.218848 6.98988C0.512598 6.69925 0.987598 6.69613 1.27822 6.98988L1.96885 7.6805L3.69072 5.768C3.96885 5.45863 4.44072 5.43363 4.7501 5.71175H4.75322ZM7.0001 2.518C7.0001 1.96488 7.44697 1.518 8.0001 1.518H15.0001C15.5532 1.518 16.0001 1.96488 16.0001 2.518C16.0001 3.07113 15.5532 3.518 15.0001 3.518H8.0001C7.44697 3.518 7.0001 3.07113 7.0001 2.518ZM7.0001 7.518C7.0001 6.96488 7.44697 6.518 8.0001 6.518H15.0001C15.5532 6.518 16.0001 6.96488 16.0001 7.518C16.0001 8.07113 15.5532 8.518 15.0001 8.518H8.0001C7.44697 8.518 7.0001 8.07113 7.0001 7.518ZM5.0001 12.518C5.0001 11.9649 5.44697 11.518 6.0001 11.518H15.0001C15.5532 11.518 16.0001 11.9649 16.0001 12.518C16.0001 13.0711 15.5532 13.518 15.0001 13.518H6.0001C5.44697 13.518 5.0001 13.0711 5.0001 12.518ZM1.5001 11.018C1.89792 11.018 2.27945 11.176 2.56076 11.4573C2.84206 11.7386 3.0001 12.1202 3.0001 12.518C3.0001 12.9158 2.84206 13.2974 2.56076 13.5787C2.27945 13.86 1.89792 14.018 1.5001 14.018C1.10227 14.018 0.720742 13.86 0.439437 13.5787C0.158133 13.2974 9.76473e-05 12.9158 9.76473e-05 12.518C9.76473e-05 12.1202 0.158133 11.7386 0.439437 11.4573C0.720742 11.176 1.10227 11.018 1.5001 11.018Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }